import { Edit, Trash } from 'react-feather';
import { Button, Table } from 'react-bootstrap';

const OrderItemList = ({ ordereditem, onEdit, onDelete }) => {
  return (
    <Table
      striped
      bordered
      hover
      responsive
      className="align-middle text-center mt-4"
    >
      <thead className="table-dark">
        <tr>
          <th>S.No</th>
          <th>Product ID</th>
          <th>Weight (g)</th>
          <th>Gold Rate</th>
          <th>Total Amount</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {ordereditem.length === 0 ? (
          <tr>
            <td colSpan="6" className="text-center">
              No items added
            </td>
          </tr>
        ) : (
          ordereditem.map((data, index) => (
            <tr key={data.id || index}>
              <td>{index + 1}</td>
              <td>{data.productId}</td>
              <td>{data.weight}</td>
              <td>{data.goldRate}</td>
              <td>₹{data.totalAmount?.toLocaleString()}</td>
              <td>
                <Button
                  variant="warning"
                  size="sm"
                  className="me-2"
                  onClick={() => onEdit(data)}
                >
                  <Edit />
                </Button>
                {/* <Button
                  variant="danger"
                  size="sm"
                  onClick={() => onDelete(data.id)}
                >
                  <Trash />
                </Button> */}
              </td>
            </tr>
          ))
        )}
      </tbody>
    </Table>
  );
};

export default OrderItemList;